import { HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";
import map from "lodash/map";
const retryDelays = map([0, 3, 10, 20, 45, 60], s => s * 1000);
const checkConnectionStateInterval = 1000;
class SignalR {
    start(closeCallback, retryCallback, successCallback) {
        this.connection = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_API_BASE_URL}/main`)
            .withAutomaticReconnect(retryDelays)
            .build();
        this.connection.start();
        if (closeCallback) {
            this.closeCallback = closeCallback;
            this.connection.onclose(closeCallback);
        }
        if (retryCallback) {
            this.retryCallback = retryCallback;
            this.connection.onreconnecting(retryCallback);
        }
        if (successCallback) {
            this.successCallback = successCallback;
            this.connection.onreconnected(successCallback);
        }
    }
    reconnect() {
        var _a;
        this.checkConnection();
        (_a = this.connection) === null || _a === void 0 ? void 0 : _a.start();
        if (this.retryCallback) {
            this.retryCallback();
        }
        this.checkConnectionStateInterval && clearInterval(this.checkConnectionStateInterval);
        this.checkConnectionStateInterval = setInterval(() => {
            var _a, _b;
            this.checkConnection();
            if (((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Disconnected) {
                this.checkConnectionStateInterval && clearInterval(this.checkConnectionStateInterval);
                this.closeCallback && this.closeCallback();
            }
            if (((_b = this.connection) === null || _b === void 0 ? void 0 : _b.state) === HubConnectionState.Connected) {
                this.checkConnectionStateInterval && clearInterval(this.checkConnectionStateInterval);
                this.successCallback && this.successCallback();
            }
        }, checkConnectionStateInterval);
    }
    checkConnection() {
        if (!this.connection) {
            throw new Error("SignalR connection not established");
        }
    }
    subscribe(methodName, handler) {
        var _a;
        this.checkConnection();
        (_a = this.connection) === null || _a === void 0 ? void 0 : _a.on(methodName, handler);
    }
    unsubscribe(methodName, handler) {
        var _a;
        this.checkConnection();
        (_a = this.connection) === null || _a === void 0 ? void 0 : _a.off(methodName, handler);
    }
}
const signalRInstance = new SignalR();
export default signalRInstance;
